import React, {useState} from 'react'
import {Button, Input, message, Modal, Result} from "antd"

import {useClubMemberContext} from "../store/useClubMemberContext"
import {addBlackList, deleteBlackList} from "../../../api/clubMemberList"
import {UserAddOutlined, UserDeleteOutlined} from "@ant-design/icons"

const ClubMemberBlack = ({member}) => {

    const {fetchClubMemberList}=useClubMemberContext()

    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [note, setNote] = useState('')


    const handleOk = async () => {
        if (!note.length && !member.isInBlacklist) {
            message.error("请输入备注")
            return
        }
        setIsLoading(true)
        if (member.isInBlacklist) {
            await deleteBlackList(member.id).then(res => {
                if (res.status) {
                    message.success('移除成功')
                    setIsShow(false)
                } else {
                    message.error(`移除失败：${res.detail}`)
                }
            }).catch(err => {
                message.error(`移除失败：${err.message}`)
            }).finally(() => {
                setIsLoading(false)
                fetchClubMemberList()
            })
        } else {
            await addBlackList(member.id,note).then(res => {
                if (res.status) {
                    message.success('拉黑成功')
                    setIsShow(false)
                } else {
                    message.error(`拉黑失败：${res.detail}`)
                }
            }).catch(err => {
                message.error(`拉黑失败：${err.message}`)
            }).finally(() => {
                setIsLoading(false)
                fetchClubMemberList()
            })
        }
    }

    return <div>
        <Button type={"primary"}
                icon={member.isInBlacklist ? <UserDeleteOutlined/> : <UserAddOutlined/>}
                style={{background: member.isInBlacklist ? 'rgb(56 158 13)' : '', border: 0}}
                danger={!member.isInBlacklist}
                onClick={() => setIsShow(true)}>{member.isInBlacklist ? '解除' : '拉黑'}</Button>
        <Modal
            open={isShow}
            onCancel={() => setIsShow(false)}
            onOk={handleOk}
            confirmLoading={isLoading}
        >
            <Result
                status={"warning"}
                title={`确定将 ${member.nickName} ${member.isInBlacklist ? '移除' : '加入'}黑名单吗？`}
                extra={(
                    <div>
                        {!member.isInBlacklist ?<Input
                            placeholder="请输入备注"
                            onChange={(e) => {
                            setNote(e.target.value)
                        }}></Input> : ''}
                    </div>
                )}
            >
            </Result>
        </Modal>
    </div>

}
export default ClubMemberBlack


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberBlack.js